import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import { Avatar, ReviewRating, UserDisplayName } from '../../components';

import css from './Reviews.module.css';
import { getDurationFromNow } from '../../util/data';

const Review = props => {
  const { review, intl } = props;
  const authorCreatedAt = review.author.attributes.createdAt;
  const durationFromNow = getDurationFromNow(authorCreatedAt);
  const date = review.attributes.createdAt;
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });

  return (
    <div className={css.review}>
      <div className={css.avatarNTitle}>
        <Avatar className={css.avatar} user={review.author} />

        <div className={css.userdetail}>
          <UserDisplayName user={review.author} intl={intl} />
          <FormattedMessage id="Reviews.duration" values={{ duration: durationFromNow }} />
        </div>
      </div>

      <div>
        <ReviewRating
          rating={review.attributes.rating}
          className={css.mobileReviewRating}
          reviewStarClassName={css.reviewRatingStar}
        />
        <p className={css.reviewInfo}>
          <span className={css.desktopReviewRatingWrapper}>
            <ReviewRating
              rating={review.attributes.rating}
              className={css.desktopReviewRating}
              reviewStarClassName={css.reviewRatingStar}
            />
          </span>
          <span className={css.desktopSeparator}>•</span>
          {dateString}
        </p>
        <p className={css.reviewContent}>{review.attributes.content}</p>
      </div>
    </div>
  );
};

/**
 * A component that renders a list of reviews.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {Array<propTypes.review>} props.reviews - The reviews to render
 * @returns {JSX.Element}
 */
const Reviews = props => {
  const intl = useIntl();
  const { className, rootClassName, reviews = [] } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <>
      <ul className={classes}>
        {reviews.map(r => {
          return (
            <li key={`Review_${r.id.uuid}`} className={css.reviewItem}>
              <Review review={r} intl={intl} />
            </li>
          );
        })}
      </ul>
      <button className={css.showMoreBtn}><FormattedMessage id="Reviews.showMoreReviews" /></button>
    </>
  );
};

export default Reviews;
